// account status
export const ATTENDANCE_CHANGE_APPROVAL_STATUS_PENDING = 1;
export const ATTENDANCE_CHANGE_APPROVAL_STATUS_APPROVED = 2;
export const ATTENDANCE_CHANGE_APPROVAL_STATUS_REJECTED = 3;

export const ATTENDANCE_CHANGE_APPROVAL_STATUS_NAMES = {
    1: 'Pending',
    2: 'Approved',
    3: 'Rejected'
};

export const ATTENDANCE_CHANGE_APPROVAL_STATUS_DROPDOWN_OPTIONS = [
    { value: ATTENDANCE_CHANGE_APPROVAL_STATUS_PENDING, label: ATTENDANCE_CHANGE_APPROVAL_STATUS_NAMES[ATTENDANCE_CHANGE_APPROVAL_STATUS_PENDING] },

    { value: ATTENDANCE_CHANGE_APPROVAL_STATUS_APPROVED, label: ATTENDANCE_CHANGE_APPROVAL_STATUS_NAMES[ATTENDANCE_CHANGE_APPROVAL_STATUS_APPROVED] },
    
    { value: ATTENDANCE_CHANGE_APPROVAL_STATUS_REJECTED, label: ATTENDANCE_CHANGE_APPROVAL_STATUS_NAMES[ATTENDANCE_CHANGE_APPROVAL_STATUS_REJECTED] },
];
